import cn from "classnames";
import { useUnreadItems } from "contexts/unreadItemsContext";
import { bidChatFlags, bidChatFlagsEnum } from "helpers/enums";
import { enumLabel, flagVal, formattedCount } from "helpers/system";
import Tooltip from "rc-tooltip";
import React, { useEffect, useState } from "react";
import { chatMessagesCount } from "sources/books/chats";

const hasUploadedFileFlagVal = flagVal(bidChatFlags, bidChatFlagsEnum.HasUploadedFile);

export default function Notifys(props) {
    const { count: countProp, chatId, chatType, action, cname, intChatFlags } = props;
    const { readItems } = useUnreadItems();

    const [count, setCount] = useState(countProp || 0);

    useEffect(() => {
        if (countProp === undefined && chatId) {
            chatMessagesCount(chatId).then((res) => setCount(res));
        }
    }, [chatId, countProp]);

    const toChat = () => {
        if (action) {
            if (count > 0) {
                readItems({ chatId, chatType });
                setCount(0);
            }
            action();
        }
    };

    const ownCname = cn("notifys", { [cname]: !!cname });
    const hasUploadedFile = !!intChatFlags && (intChatFlags & hasUploadedFileFlagVal) === hasUploadedFileFlagVal;

    return (
        <div className={ownCname} onClick={toChat}>
            {!!count && <div className="notifys__count">{formattedCount(count)}</div>}
            {hasUploadedFile && (
                <Tooltip
                    placement="bottom"
                    overlayClassName="notifys__tooltip"
                    overlay={enumLabel(bidChatFlags, bidChatFlagsEnum.HasUploadedFile)}
                >
                    <div className="notifys__attachment" />
                </Tooltip>
            )}
        </div>
    );
}
